import { getRequest } from "./export";
import { baseUrl } from "../../endpoints";
import { configReq } from "../../../lib/functions";

/** Search compatibility must also preserve the matching ID set in exported files. */
export function createSearchExport(listEndpoint, requestPage) {
  return async (api, extra, ids, temp, token) => {
    const query = new URLSearchParams(String(temp || "").replace(/^[?&]/, ""));
    if (!query.get("search") || ids) return getRequest(api, extra, ids, temp, token);
    query.set("Page", "1"); query.set("Limit", "2147483647");
    const listing = await requestPage(`${baseUrl}/${listEndpoint}?${query}`, configReq(token));
    const matchingIds = listing.data.data.map((row) => row.id ?? row.Id);
    query.delete("Page"); query.delete("Limit"); query.delete("search");
    const response = await getRequest(api, extra, matchingIds.length ? `,${matchingIds.join(",")}` : "", `&${query}`, token);
    if (!matchingIds.length) return { ...response, data: { ...response.data, data: { ...response.data.data, body: [] } } };
    if (response.data?.data?.body?.length !== matchingIds.length) throw new Error("تعداد رکوردهای خروجی با نتایج جستجو مطابقت ندارد؛ فایل ساخته نشد.");
    return response;
  };
}
